import { render, staticRenderFns } from "./VoDCard.vue?vue&type=template&id=74ff526e"
import script from "./VoDCard.vue?vue&type=script&lang=ts"
export * from "./VoDCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports